import React from 'react';
import { Navigate } from 'react-router';

import { PortfolioLtvChartTemplateForOrganization } from './PortfolioLtvChartTemplateForOrganization';
import { useCreditFacilitiesOrThrow } from '~/contexts/CreditFacilitiesProvider';
import { RouteErrorBoundary } from '~/contexts/MonitoringProvider';
import { useUserAuthOrThrow } from '~/contexts/UserAuthProvider';
import { PermissionGuard, PermissionsFn } from '~/core/PermissionGuard';

// Fragments
const RouteBase = () => {
  const { user } = useUserAuthOrThrow();
  const { facilities } = useCreditFacilitiesOrThrow();

  return (
    <PortfolioLtvChartTemplateForOrganization
      organizationId={user.organization.id}
      creditFacilities={facilities}
    />
  );
};

// Exports
export const permissions: PermissionsFn = (context) => {
  return context.flags.productsAnalyticsRiskPermissions;
};
export const Route = () => {
  return (
    <PermissionGuard
      permissions={permissions}
      fallback={<Navigate to="/" replace />}
    >
      <RouteErrorBoundary
        fallback={({ message, showErrorToast }) => {
          showErrorToast(message);
          return <Navigate to="/" />;
        }}
      >
        <RouteBase />
      </RouteErrorBoundary>
    </PermissionGuard>
  );
};
